/**
 * External dependencies
 */
import vd from "lib/vd";

/**
 * Internal dependencies
 */
import {
  PREFERENCES_SET,
  PREFERENCES_RECEIVE,
  PREFERENCES_FETCH,
  PREFERENCES_FETCH_SUCCESS,
  PREFERENCES_FETCH_FAILURE,
  PREFERENCES_SAVE,
} from "state/action-types";
import { getAllRemotePreferences } from "state/preferences/selectors";

export const receivePreferences = (values) => {
  return {
    type: PREFERENCES_RECEIVE,
    values,
  };
};

export const fetchPreferences = () => {
  return (dispatch) => {
    dispatch({
      type: PREFERENCES_FETCH,
    });

    return vd
      .preferences()
      .getPreferences()
      .then((preferences) => {
        dispatch({ type: PREFERENCES_FETCH_SUCCESS, values: preferences });
        dispatch({ type: PREFERENCES_RECEIVE, values: preferences });
      })
      .catch((error) =>
        dispatch({
          type: PREFERENCES_FETCH_FAILURE,
          error,
        })
      );
  };
};

export const setPreference = (key, value) => ({
  type: PREFERENCES_SET,
  key,
  value,
});

export const savePreference = (key, value) => async (dispatch, getState) => {
  dispatch(setPreference(key, value));
  dispatch({
    type: PREFERENCES_SAVE,
    key,
    value,
  });

  const payload = {
    // ...preferences,
    [key]: value,
  };

  return await vd
    .preferences()
    .savePreferences(payload)
    .then((response) => {
      console.log(response);
    });
};
